
























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { ICheckoutCartOfferCoupon, ICheckoutCartOffer } from '@/interfaces/Checkout';

import { EErrorExhibition, EErrorScope } from '@/helpers/enums';

import { ITraceableError } from '@/interfaces/Error';

import { EPaymentMethodTypes } from '@/helpers/enums';

import ApplyCoupon from './ApplyCoupon.vue';

const AppModule = namespace('App');
const CheckoutModule = namespace('App/Checkout');
const ErrorModule = namespace('App/Error');

@Component({
  components: {
    ApplyCoupon,
  }
})
export default class AppliedCoupon extends Vue {
  @Prop()
  private coupon!: ICheckoutCartOfferCoupon | null;

  @AppModule.Action
  private prepareCheckout: Function;

  @AppModule.State
  private cardFirstDigitsSelected: string | number | null;

  @AppModule.State
  private paymentMethodSelected: string;

  @CheckoutModule.Mutation
  private setSelectedOfferCoupon: Function;

  @CheckoutModule.Getter
  private rootOffer: ICheckoutCartOffer;

  @CheckoutModule.Getter('selectedOfferPaymentCardSelected')
  private selectedPaymentCard: any;

  @CheckoutModule.Getter
  private bankSlipAcceptedTermsChecked!: boolean;

  @CheckoutModule.State
  private enableHiddenMethods: boolean;

  @ErrorModule.Getter('errorsByExhibitionAndScope')
  private errorsByExhibitionAndScope: Function;


  private get error(): ITraceableError | null {
    const errors = this.errorsByExhibitionAndScope(EErrorExhibition.modal, [EErrorScope.payment]);

    const error = errors.find((error: ITraceableError) => {
      return error.code == 1203;
    });

    return error;
  }

  private get isCouponInvalid() {
    return (this.coupon && this.coupon.error_code) || this.error;
  }

  private get feedbackMessage () {
    if (this.isCouponInvalid) {
      let errorCode: string | number = '';

      if (this.coupon && this.coupon.error_code) {
        errorCode = this.coupon.error_code;
      } else if (this.error && this.error.code){
        errorCode = this.error.code;
      }

      return this.$t(`App.Checkout.Offer.Coupon.Errors.${errorCode}`);
    } else {
      return 'Cupom ativado com sucesso!';
    }
  }

  private get isMobile (): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private removeCoupon() {
    this.setSelectedOfferCoupon(null);

    return this.prepareCheckout({
      slug: this.rootOffer.slug,
      payload: {
        coupon: null,
        payment_method: this.paymentMethodSelected,
        ...(this.cardFirstDigitsSelected && this.paymentMethodSelected === EPaymentMethodTypes.creditCard && {
          card_first_digits: this.cardFirstDigitsSelected,
        }),
        ...(this.bankSlipAcceptedTermsChecked && {
          is_payment_in_installments: this.bankSlipAcceptedTermsChecked,
          is_terms_accepted: this.bankSlipAcceptedTermsChecked,
        })
      },
      ...(this.enableHiddenMethods) && {
        enableHiddenMethods: this.enableHiddenMethods,
      }
    });
  }
}
